module.exports = __webpack_public_path__ + "53e2a1c94b37e5c9cdba8928a96f6fd4.MP3";